"use client"

import React from "react"
import { Profile } from "@/features/auth/types/auth-actions.type"
import { UserRole } from "@/shared/constants/user-roles"
import ProfileAboutMeForm from "./profile-about-me-form"
import HomeownerProfileForm from "./homeowner-profile-form"

interface ProfileFormProps {
    profile: Profile
    currentStep?: number
    role: UserRole
    /** Current user id (for volunteer profile); used to call volunteer API for save/refetch */
    userId?: number
}

/**
 * Unified Profile Form Component
 * Conditionally renders the appropriate form component based on user role
 * This provides a single entry point while maintaining the existing form implementations
 */
function ProfileForm({ profile, currentStep, role, userId }: ProfileFormProps) {
    const isHomeowner = role === UserRole.HOMEOWNER

    return isHomeowner ? (
        <HomeownerProfileForm profile={profile} currentStep={currentStep} />
    ) : (
        <ProfileAboutMeForm profile={profile} currentStep={currentStep} userId={userId} />
    )
}

export default ProfileForm

